<template>
  <div>
    <loading name="lp" :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <base-header class="pb-6">
      <div class="row align-items-center py-0"></div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
          <template slot="header">
            <h3 class="mb-0">Class</h3>
            <p class="text-sm mb-0">The list of classes.</p>
          </template>
          <div>
            <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
              <div>
                <base-button type="primary" @click.prevent="onNew">
                  <span class="btn-inner--icon">
                    <i class="ni e-add"></i>
                  </span>New class
                </base-button>
                <base-button type="info" @click.prevent="onRefresh" icon>
                  <span class="btn-inner--icon">
                    <i class="ni refresh-02"></i>
                  </span>Refresh
                </base-button>
              </div>
              <el-select class="select-primary pagination-select" v-model="status">
                <el-option
                  class="select-primary"
                  v-for="(item,index) in statuses"
                  :key="index"
                  :label="item"
                  :value="index + 1"
                ></el-option>
              </el-select>
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>

              <div>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Search..."
                ></base-input>
              </div>
            </div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
            >
              <el-table-column>
                <div slot-scope="{row}">
                  <div class="row">
                    <div class="col-lg-2">
                      <h5 class="mb-10">Course</h5>
                    </div>
                    <div class="col-lg-10">{{row.coursecode}}.{{row.coursetitle}}</div>

                    <div class="col-lg-2">
                      <h5 class="mb-0">Class code</h5>
                    </div>
                    <div class="col-lg-2">{{row.code}}</div>
                    <div class="col-lg-2">
                      <h5 class="mb-0">Reposnible</h5>
                    </div>
                    <div class="col-lg-2">{{row.resppersonname}}</div>
                    <div class="col-lg-2">
                      <h5 class="mb-0">Students</h5>
                    </div>
                    <div class="col-lg-2">{{row.studentcount}}</div>

                    <div class="col-lg-2">
                      <h5 class="mb-0">Start date</h5>
                    </div>
                    <div class="col-lg-2">{{row.startdate}}</div>
                    <div class="col-lg-2">
                      <h5 class="mb-0">End date</h5>
                    </div>
                    <div class="col-lg-2">
                      <span
                        :class="{'text-danger': row.overdue === '1'}"
                      >{{row.enddate ? row.enddate : "Not finished"}}</span>
                    </div>
                    <div class="col-lg-2">
                      <h5 class="mb-0">Due date</h5>
                    </div>
                    <div class="col-lg-2">{{row.approxenddate }}</div>

                    <div class="col-lg-2">
                      <h5 class="mb-0">Course dur</h5>
                    </div>
                    <div class="col-lg-2">{{row.courseduration}} week(s)</div>
                    <div class="col-lg-2">
                      <h5 class="mb-0">Elapsed</h5>
                    </div>
                    <div class="col-lg-2">{{row.courseprogress}} %</div>
                    <div class="col-lg-2">
                      <h5 class="mb-0">Status</h5>
                    </div>
                    <div class="col-lg-2">
                      <span
                        v-if="row.courseprogress/row.progress > 1.5"
                        class="text-warning"
                      >Need attention</span>
                      <span v-else class="text-success">Normal</span>
                    </div>

                    <div class="col-lg-2">
                      <h5 class="mb-0">Lessons</h5>
                    </div>
                    <div class="col-lg-2">{{row.totallessoncount}}</div>
                    <div class="col-lg-2">
                      <h5 class="mb-0">Finished</h5>
                    </div>
                    <div class="col-lg-2">{{row.finishedlessoncount}}</div>
                    <div class="col-lg-2">
                      <h5 class="mb-0">Progress</h5>
                    </div>
                    <div class="col-lg-2">{{row.progress}} %</div>
                  </div>
                </div>
              </el-table-column>
              <el-table-column width="150px" align="right" label="Actions">
                <div slot-scope="{$index, row}" class="d-flex">
                  <base-button
                    @click.native="onEdit($index, row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                  >
                    <i class="text-white ni n-edit"></i>
                  </base-button>
                  <base-button
                    @click.native="onDelete($index, row)"
                    class="remove btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-white ni e-remove"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            ></base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "@/components";
import classTableMixin from "./classTableMixin";
import swal from "sweetalert2";
import { nophoto } from "../../../services/user";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  mixins: [classTableMixin],
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Loading,
  },
  data() {
    return {
      status: 1,
      statuses: ["Active", "Inactive"],
      tableData: [],
      isLoading: false,
    };
  },
  methods: {
    onNew() {
      this.$router
        .push({ path: "/class", params: { id: "" } })
        .catch((e) => {});
    },
    onEdit(index, row) {
      this.$router.push({ path: "/class/" + row.id }).catch((e) => {});
    },
    onDelete(index, row) {
      swal
        .fire({
          title: "Are you sure?",
          text: `You won't be able to revert this!`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn btn-success btn-fill",
          cancelButtonClass: "btn btn-danger btn-fill",
          confirmButtonText: "Yes, delete it!",
          buttonsStyling: false,
        })
        .then((result) => {
          if (result.value) {
            this.deleteRow(row);
          }
        });
    },
  },
  watch: {
    status: function () {
      this.onLoad();
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
